import * as React from "react";
import { EventCardSectionItem } from "../../EventCardSectionItem";
export const renderMiniTeamsScore = (score1, score2) => React.createElement("div", { className: "rj-ev-list__mini-ev-card__scores-inner" },
    React.createElement(EventCardSectionItem, { content: score1, className: "rj-ev-list__mini-ev-card__score rj-ev-list__mini-ev-card__score-home" }),
    "-",
    React.createElement(EventCardSectionItem, { content: score2, className: "rj-ev-list__mini-ev-card__score rj-ev-list__mini-ev-card__score-away" }));
//# sourceMappingURL=renderMiniTeamsScore.js.map